import { useEffect, useState } from 'react';
import { Card, Empty, ErrorBanner } from '../components/Layout.jsx';
import { apiFetch } from '../store.js';

export default function EngineQuality() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    apiFetch('/dashboard/engine-quality')
      .then((d) => { if (!cancelled) setData(d); })
      .catch((e) => { if (!cancelled) setError(e); });
    return () => { cancelled = true; };
  }, []);

  const engines = data?.engines || [];

  return (
    <>
      <ErrorBanner error={error} />
      <Card title="Engine quality">
        {engines.length === 0 ? <Empty>No engine runs recorded yet.</Empty> : (
          <table>
            <thead>
              <tr>
                <th>Engine</th>
                <th>Runs</th>
                <th>Successes</th>
                <th>Success rate</th>
                <th>Avg latency</th>
                <th>Last run</th>
              </tr>
            </thead>
            <tbody>
              {engines.map((e) => {
                const runs = Number(e.runs) || 0;
                const successes = Number(e.successes) || 0;
                const rate = runs ? Math.round((successes / runs) * 100) : 0;
                return (
                  <tr key={e.engine_name}>
                    <td>{e.engine_name}</td>
                    <td>{runs}</td>
                    <td>{successes}</td>
                    <td>{rate}%</td>
                    <td>
                      {e.avg_latency_ms != null ? `${Math.round(e.avg_latency_ms)}ms` : '—'}
                    </td>
                    <td>{e.last_run_at || '—'}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </Card>
    </>
  );
}
